/* eslint-disable */

import request from '@/utils/request'

export function getListHouseKeepingApi(data) {
  return request({
    url: '/chamber-service/v1/housekeeping/list',
    method: 'post',
    data: data
  })
}

export function changeStatusHouseKeepingApi(data) {
  return request({
    url: '/chamber-service/v1/housekeeping',
    method: 'put',
    data: data
  })
}

export function houseKeepingAssignApi(query) {
  return request({
    url: '/chamber-service/v1/housekeeping/assign',
    method: 'post',
    data: query
  })
}

export function getListStaffApi(query) {
  return request({
    url: '/chamber-service/v1/housekeeping/chamber-staff',
    method: 'get'
  })
}

export function getListOT(query) {
  return request({
    url: '/chamber-service/v1/housekeeping/ot',
    method: 'get',
    params: query
  })
}

export function deleteListOT(query) {
  return request({
    url: '/chamber-service/v1/housekeeping',
    method: 'delete',
    data: query
  })
}
